import { render, staticRenderFns } from "./SpecialEvents.vue?vue&type=template&id=9e20f1a4"
import script from "./SpecialEvents.vue?vue&type=script&lang=js"
export * from "./SpecialEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports